import big5 from './big5.js'
import eng from './eng.js'

let clang = big5
if (window.localStorage.guanwanglang == 'eng') {
    clang = eng
}else{
    clang = big5
}
export default clang



// WEBPACK FOOTER //
// ./src/assets/language.js